"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2017-2022 @darwinia/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
// order important in structs... :)

/* eslint-disable sort-keys */
var _default = {
  rpc: {},
  types: {// Grandpa: {
    //   Equivocation: 'GrandpaEquivocation',
    //   EquivocationProof: 'GrandpaEquivocationProof'
    // },
    // GrandpaEquivocation: {
    //   _enum: {
    //     Prevote: 'GrandpaEquivocationValue',
    //     Precommit: 'GrandpaEquivocationValue'
    //   }
    // },
    // GrandpaEquivocationProof: {
    //   setId: 'SetId',
    //   equivocation: 'GrandpaEquivocation'
    // },
    // GrandpaEquivocationValue: {
    //   roundNumber: 'u64',
    //   identity: 'AuthorityId',
    //   first: '(GrandpaPrevote, AuthoritySignature)',
    //   second: '(GrandpaPrevote, AuthoritySignature)'
    // },
    // GrandpaPrevote: {
    //   targetHash: 'Hash',
    //   targetNumber: 'BlockNumber'
    // },
    // AuthoritySignature: 'Signature'
    // Signature: 'H512'
  }
};
exports.default = _default;